import type { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const adminCouponRoutes: RouteRecordRaw[] = [
  {
    path: '/coupon',
    name: 'Coupon',
    component: Layout,
    meta: {
      title: '优惠券管理',
      icon: 'mdi:ticket-percent-outline',
      alwaysShow: true
    },
    children: [
      {
        path: 'category',
        name: 'CouponCategory',
        component: () => import('@/views/Admin/Coupon/Category.vue'),
        meta: {
          title: '优惠券类别',
          icon: 'mdi-tag-outline'
        }
      },
      {
        path: 'details',
        name: 'CouponDetail',
        component: () => import('@/views/Admin/Coupon/Details.vue'),
        meta: {
          title: '优惠券明细',
          icon: 'mdi-ticket-confirmation'
        }
      },
      {
        path: 'list',
        name: 'CouponList',
        component: () => import('@/views/Admin/Coupon/List.vue'),
        meta: {
          title: '优惠券列表',
          icon: 'mdi-ticket-confirmation'
        }
      },
      {
        path: 'record',
        name: 'CouponRecord',
        component: () => import('@/views/Admin/Coupon/Record.vue'),
        meta: {
          title: '发放记录',
          icon: 'mdi-gift-outline'
        }
      }
    ]
  }
]

export default adminCouponRoutes
